import { request } from 'api/request';
import { PRODUCT_RESEARCH_API_URLS } from 'api/constants';
// TODO ARTEM move catalog utility and categories to common Data class
export default class Catalog {
  static getCatalog(search) {
    return request({
      url: PRODUCT_RESEARCH_API_URLS.catalog.getCatalog,
      search,
    });
  }
}
